import { useEffect, useState } from 'react';

import { useUpdatePiecesMutation } from '@api/piece';
import { Piece, PieceAction } from '@apiContract';

import { usePiecePdf } from '@components/Mailpiece/hooks/usePiecePdf';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { ActionComponentProps } from '../../../index';
import { DialogOpenAndScan } from './components/DialogOpenAndScan';

export const mailpieceHasContent = (mailpiece: Piece) =>
  Boolean(mailpiece.pieceDoc?.piecePages.length || mailpiece.pieceDoc?.pdfUrl);

export const OpenAndScan = ({ mailpieces, actionStarted, onActionFinish }: ActionComponentProps) => {
  const [updatePieces] = useUpdatePiecesMutation();

  const mailpiece = mailpieces[0];

  const { handleCreatePdfFromPages } = usePiecePdf(mailpiece.id, mailpiece.pieceDoc || null);

  const [actionInProgress, setActionInProgress] = useState<boolean>(false);
  const [openAndScanOpen, setOpenAndScanOpen] = useState<boolean>(false);
  const [finishOpenAndScanOpen, setFinishOpenAndScanOpen] = useState<boolean>(false);

  useEffect(() => {
    if (actionStarted) {
      if (openAndScanOpen || finishOpenAndScanOpen) return;
      const fn = !mailpieceHasContent(mailpiece) ? setOpenAndScanOpen : setFinishOpenAndScanOpen;
      fn(true);
    } else {
      setOpenAndScanOpen(false);
      setFinishOpenAndScanOpen(false);
    }
  }, [actionStarted, mailpiece, openAndScanOpen, finishOpenAndScanOpen]);

  const handleOpenAndScanComplete = () => {
    setOpenAndScanOpen(false);
    setFinishOpenAndScanOpen(true);
  };

  const confirmFinishOpenAndScan = async () => {
    try {
      setActionInProgress(true);

      if (!mailpiece.pieceDoc?.pdfUrl) {
        await handleCreatePdfFromPages();
      }

      await updatePieces({ pieces: [{ id: mailpiece.id }], action: PieceAction.FinishOpenAndScan }).unwrap();
    } catch (error) {
      console.error(error);
    } finally {
      setActionInProgress(false);
      onActionFinish();
    }
  };

  return (
    <>
      <DialogOpenAndScan
        mailpieces={mailpieces}
        actionStarted={openAndScanOpen}
        onActionFinish={onActionFinish}
        onOpenAndScanComplete={handleOpenAndScanComplete}
      />

      <DialogConfirmation
        open={finishOpenAndScanOpen}
        loading={actionInProgress}
        maxWidth="sm"
        title="Send Content"
        content="Are you sure you want to finish Open and Scan and send content to the recipient?"
        acceptButtonHandleClick={confirmFinishOpenAndScan}
        cancelButtonHandleClick={onActionFinish}
        acceptButtonTitle="Complete"
        cancelButtonTitle="Cancel"
      />
    </>
  );
};
